module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel notes mb-4"
  }, [_c('h5', [_vm._v("Notes & Alerts")]), _vm._v(" "), (_vm.moments && _vm.canAdd) ? _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "Leave an important alert ..."
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveNote($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.moments,
      "searchable": false,
      "label": "description",
      "placeholder": "- Select moment -"
    },
    on: {
      "input": _vm.updateMoment
    },
    model: {
      value: (_vm.selectedMoment),
      callback: function($$v) {
        _vm.selectedMoment = $$v
      },
      expression: "selectedMoment"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn blue ml-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveNote
    }
  }, [_c('i', {
    staticClass: "ico-add"
  }), _vm._v("\n                Add note\n            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.form.notes && _vm.form.notes.length > 0) ? _c('ul', _vm._l((_vm.form.notes), function(note, index) {
    return _c('li', {
      staticClass: "d-flex my-3 relative"
    }, [_c('note', {
      attrs: {
        "reservation": _vm.form,
        "index": index
      }
    })], 1)
  }), 0) : _c('div', [_vm._v("\n        No notes found.\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-67c9b812", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c9b812"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Notes.vue
// module id = 1241
// module chunks = 0